// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"391":"dfcdb00e","840":"c75b3a80"}[chunkId] + ".chunk.css";
};